import { Directive, input } from "@angular/core";
import { ToggleSideNav } from "./toggle-side-nav";
import { SideNavStatusEnum } from "../interfaces/side-nav-status.enum";

@Directive({
  selector: "[selectedItem]",
})
export class SelectedItemDirective extends ToggleSideNav {
  override sideNav = input.required<HTMLDivElement>({ alias: "selectedItem" });

  selectedItemId = input.required<string>();
  currentSelectedItemId = input.required<string | null>();

  hasNestedItems = input.required<boolean>();

  protected override calcSideNavStatus(): void {
    this.status.update(status => {
      if (this.hasNestedItems()) {
        if (this.currentSelectedItemId() === this.selectedItemId() && status === SideNavStatusEnum.expanded) return SideNavStatusEnum.collapse;
        else if (this.currentSelectedItemId() === this.selectedItemId() && status === SideNavStatusEnum.collapse) return SideNavStatusEnum.expanded;
        else if (this.currentSelectedItemId() !== this.selectedItemId()) return SideNavStatusEnum.expanded;
        else return SideNavStatusEnum.collapse;
      } else return null;
    });
  }
}
